"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the number for the fibonacci sequence. used to define incremental timeouts
 * for retrying network requests
 *
 * @param offset - The offset in the fibonacci sequence to look for
 */
function getFibonacciSequence(offset) {
    var _a = [0, 1], firstNumber = _a[0], secondNumber = _a[1];
    var iterator = 1;
    while (iterator < offset) {
        var tempSum = firstNumber + secondNumber;
        firstNumber = secondNumber;
        secondNumber = tempSum;
        iterator += 1;
    }
    return secondNumber;
}
exports.default = getFibonacciSequence;
//# sourceMappingURL=getFibonacciSequence.js.map